import { CommandProps } from '@tiptap/core';
import { TextSelection, Transaction } from '@tiptap/pm/state';

export const setSelection = (tr: Transaction, from: number, to: number) => {
  tr.setSelection(TextSelection.create(tr.doc, from, to));
};

export const setSelectionCommand =
  (from: number, to: number) =>
  ({ tr }: CommandProps) => {
    setSelection(tr, from, to);

    return true;
  };
